import { FC, SVGProps } from "react";

const HotelIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" stroke="currentcolor" {...props}>
      <path d="M8.3335 18.3333V12.8583" />
      <path d="M10 9.16663H10.0083" />
      <path d="M10 5.83337H10.0083" />
      <path d="M11.6665 12.8583V18.3333"/>
      <path
        d="M12.5 13.3333C11.7788 12.7924 10.9015 12.5 10 12.5C9.09846 12.5 8.22123 12.7924 7.5 13.3333"
      />
      <path d="M13.3335 9.16663H13.3418" />
      <path d="M13.3335 5.83337H13.3418" />
      <path d="M6.6665 9.16663H6.67484"/>
      <path d="M6.6665 5.83337H6.67484" />
      <path
        d="M15.0002 1.66663H5.00016C4.07969 1.66663 3.3335 2.41282 3.3335 3.33329V16.6666C3.3335 17.5871 4.07969 18.3333 5.00016 18.3333H15.0002C15.9206 18.3333 16.6668 17.5871 16.6668 16.6666V3.33329C16.6668 2.41282 15.9206 1.66663 15.0002 1.66663Z"
      />
    </svg>
  );
};

export default HotelIcon;
